import {
  AirportTowerIcon,
  PalletsIcon,
  PodIcon,
  PolIcon,
  StorehouseIcon,
  SvgIconProps,
  WarehouseIcon,
} from '@freighthub/silhouette-core'
import { ComponentType, FC } from 'react'

export const PDAD_ICON_POL = 'pol'
export const PDAD_ICON_POD = 'pod'
export const PDAD_ICON_WAREHOUSE = 'warehouse'
const PDAD_ICON_STOREHOUSE = 'storehouse'
export const PDAD_ICON_AIRPORT = 'airportTower'
export const PDAD_ICON_PALLETS = 'pallets'

export type TPdadStepIconType =
  | typeof PDAD_ICON_POL
  | typeof PDAD_ICON_POD
  | typeof PDAD_ICON_WAREHOUSE
  | typeof PDAD_ICON_STOREHOUSE
  | typeof PDAD_ICON_AIRPORT
  | typeof PDAD_ICON_PALLETS

const PdadStepIconsMap = {
  [PDAD_ICON_POL]: PolIcon,
  [PDAD_ICON_POD]: PodIcon,
  [PDAD_ICON_WAREHOUSE]: WarehouseIcon,
  [PDAD_ICON_STOREHOUSE]: StorehouseIcon,
  [PDAD_ICON_AIRPORT]: AirportTowerIcon,
  [PDAD_ICON_PALLETS]: PalletsIcon,
}

type TPdadStepIconProps = {
  iconType: TPdadStepIconType
} & SvgIconProps

export const PdadStepIcon: FC<TPdadStepIconProps> = (props) => {
  const { iconType, ...rest } = props
  const Icon: ComponentType<SvgIconProps> = PdadStepIconsMap[iconType]
  return <Icon {...rest} />
}
